import './Contact.css'
import { BsGithub, BsLinkedin } from 'react-icons/bs';


const Contact = ()=> {
  return (
    <div id="contact-unit">

      <div id ="github-linkedin">
        <a href="https://github.com/CodeWithLuwam" target="_blank" rel="noreferrer"> 
          <div id="github">View my code in GitHub <BsGithub size="1.4em" id="icon"/></div> 
        </a>

        <a href="https://www.linkedin.com/in/luwam-ghebremicael/" target="_blank" rel="noreferrer">  
          <div id="linkedin">Contact me on LinkedIn <BsLinkedin size="1.4em" id="icon"/></div> 
        </a>
      </div>

    </div>
  );
}
export default Contact;